import videojs from 'video.js';
import './plugin.css';

const VERSION = '1.0.0';
const Plugin = videojs.getPlugin('plugin');
const Component = videojs.getComponent('Component');

const defaults = {
  adTagUrl: null,
};

class AdsGooglePause extends Plugin {

  constructor(player, options) {

    super(player);

    this.options = videojs.obj.merge(defaults, options);

    this.player.ready(() => {
        this.player.Simplestream().debug('GooglePauseAds Plugin Loaded');
        if(typeof google === "undefined") {
          this.player.Simplestream().errorScreen('Google Ads are not enabled in Player Settings')
        } else {
          this.init();
        }
    });

  }

  init() {

    this.buildUi();

    this.player.on('pause', () => {
      this.adUiComponent.show();
    });

    this.player.on('play', () => {
      this.adUiComponent.hide();
    });

  }

  /**
   * Renders Ad UI
   */
  buildUi() {
    class adUi extends Component {
      constructor(player, options) {
        super(player, options);
        console.log('GooglePauseAds adUi');
      }
      createEl() {

        // Create the main div
        const mainDiv = videojs.dom.createEl('div', {
          className: 'vjs-ad-ui-pause',
          id: this.player_.id_ + '_adUi-pause',
          style: 'position: absolute; top: 0px; left: 0px; height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; background: red;'
        });

        // Create the inner div
        const innerDiv = videojs.dom.createEl('div', {
          className: 'vjs-ad-ui-pause-inner',
          id: this.player_.id_ + '_adUi-pause-inner',
          style: 'width: 50%; height: 50%; background: blue;'
        });

        // Append the inner div to the main div
        mainDiv.appendChild(innerDiv);

        return mainDiv;

      }
      show() {
        super.show();
      }
      hide() {
        super.hide();
      }
    };
    videojs.registerComponent('adUi', adUi);
    this.adUiComponent = this.player.addChild('adUi', {});
    this.adUiComponent.hide();
  }

}

AdsGooglePause.defaultState = {};
AdsGooglePause.VERSION = VERSION;
videojs.registerPlugin('AdsGooglePause', AdsGooglePause);
export default AdsGooglePause;